/**
 * Copied from https://www.constantcontact.com/page-data/pricing/page-data.json#$.result.pageContext.pageData.contentfulPricing.marketingData[0]
 */
export default {
  id: 'custom-plans',
  name: 'Plans',
  features: [
    {
      id: 'custom-plans',
      feature: {
        name: 'Plans',
        tooltipLabel: '',
      },
      parameters: [
        {
          id: '1',
          value: 'Lite',
        },
        {
          id: '2',
          value: 'Standard',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Premium',
        },
      ],
    },
    {
      id: 'custom-onboarding',
      feature: {
        name: 'Onboarding',
        tooltipLabel: "You'll speak 1:1 with our experts who will get you up and running in no time!",
      },
      parameters: [
        {
          id: '1',
          value: 'Live 1:1 onboarding with experts to help you get started fast',
        },
        {
          id: '2',
          value: 'Same as Lite',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Priority onboarding by dedicated team',
        },
      ],
    },
    {
      id: 'custom-liveSupport',
      feature: {
        name: 'Live Support',
        tooltipLabel:
          'An award-winning customer support team is readily available to help customers across all plans. Premium customers receive priority support with experienced agents.',
      },
      parameters: [
        {
          id: '1',
          value: 'Live phone and chat with marketing experts',
        },
        {
          id: '2',
          value: 'Same as Lite',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Dedicated priority support team',
        },
      ],
    },
    {
      id: 'custom-email',
      feature: {
        name: 'Email',
        tooltipLabel: 'Choose from hundreds of professionally designed customizable templates or create your own.',
      },
      parameters: [
        {
          id: '1',
          value: 'Easy to use drag-and-drop email editor, AI copy generator, and email templates',
        },
        {
          id: '2',
          value: 'Email scheduling and subject line testing',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Same as Standard, plus dynamic content',
        },
      ],
    },
    {
      id: 'custom-socialMediaMarketing',
      feature: {
        name: 'Social Media Marketing',
        tooltipLabel:
          'Start posting in minutes  — all in one place. Schedule content in a few clicks, reach new audiences with social posts, and turn followers into contacts.',
      },
      parameters: [
        {
          id: '1',
          value: 'Automatic posts on Facebook, Instagram, LinkedIn, and others to find new customers',
        },
        {
          id: '2',
          value: 'Schedule all social media posts in advance',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Same as Standard',
        },
      ],
    },
    {
      id: 'custom-reporting',
      feature: {
        name: 'Reporting',
        tooltipLabel: 'See what’s working and what’s not with the ability to track your success in real time.',
      },
      parameters: [
        {
          id: '1',
          value: "Basic: See what worked and what didn't",
        },
        {
          id: '2',
          value: 'Advanced: See who opens and clicks on emails',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Same as Standard',
        },
      ],
    },
    {
      id: 'custom-automation',
      feature: {
        name: 'Automation',
        tooltipLabel:
          'Set up easy automations to make sure your emails and texts go to the right person at the right time.',
      },
      parameters: [
        {
          id: '1',
          value: '1 automation template',
        },
        {
          id: '2',
          value: '3 automation templates, AI campaign builder, and automatic resend to non-openers',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value:
            'Same as Standard, plus unlimited templates, custom automations, ecommerce templates, auto-send welcome emails',
        },
      ],
    },
    {
      id: 'custom-customerRelationshipManagement',
      feature: {
        name: 'Customer Relationship Management',
        tooltipLabel:
          'Add and manage contacts in your account. You can manually add, import a list, or create an automatic way a contact gets added to your list. Every email includes a SafeUnsubscribe® link assuring your customers that you have used a legitimate permission-based email provider.',
      },
      parameters: [
        {
          id: '1',
          value: 'Easy contact management, web signup forms, and 1 custom segment',
        },
        {
          id: '2',
          value: 'Same as Lite with 10 custom segments',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Same as Lite with unlimited custom segments',
        },
      ],
    },
    {
      id: 'custom-advertising',
      feature: {
        name: 'Advertising',
        tooltipLabel:
          'Boost awareness and traffic for your business with targeted display ads in Facebook and/or Instagram feeds.',
      },
      parameters: [
        {
          id: '1',
          value: false,
        },
        {
          id: '2',
          value: 'Powerful social media ads manager',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Same as Standard, plus Facebook lookalike targeting, Google Ad Manager, and SEO recommendations',
        },
      ],
    },
    {
      id: 'custom-events',
      feature: {
        name: 'Events',
        tooltipLabel:
          'Create, promote, and manage your event, all in one place. Enable tickets, add promo codes, and set up payment methods as part of the registration and payment process.',
      },
      parameters: [
        {
          id: '1',
          value: 'Host events, sell products, and take payments',
        },
        {
          id: '2',
          value: 'Host events, sell products, and take payments',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value: 'Host events, sell products, and take payments',
        },
      ],
    },
    {
      id: 'custom-integratedApps',
      feature: {
        name: 'Integrated Apps',
        tooltipLabel:
          'With over 300+ integrations, easily add your favorite apps to Constant Contact and sync data, simplify workflows, and amplify your marketing impact.',
      },
      parameters: [
        {
          id: '1',
          value:
            'Import your data using 300 integrations, including Google, Microsoft, Facebook, Canva, LinkedIn, Vimeo, Zapier, Shopify, Eventbrite and more!',
        },
        {
          id: '2',
          value:
            'Import your data using 300 integrations, including Google, Microsoft, Facebook, Canva, LinkedIn, Vimeo, Zapier, Shopify, Eventbrite and more!',
          variant: 'recommended' as const,
        },
        {
          id: '3',
          value:
            'Import your data using 300 integrations, including Google, Microsoft, Facebook, Canva, LinkedIn, Vimeo, Zapier, Shopify, Eventbrite and more!',
        },
      ],
    },
  ],
};
